<template>
  <div class="gsl-hrm-login-layout">
    <div class="gsl-hrm-login-layout-blob">
      <div class="gsl-hrm-login-container">
        <div class="gsl-hrm-login-slot-wrapper">
          <login-branding
            :img-src="loginBannerSrc"
            :hide-on-boarding="false"
          ></login-branding>
          <div class="gsl-hrm-login-slot">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginBranding from './LoginBranding';

export default {
  name: 'AuthLayout',
  components: {
    'login-branding': LoginBranding,
  },
  props: {
    loginBannerSrc: {
      type: String,
      required: true,
    },
  },
};
</script>

<style src="./auth-layout.scss" lang="scss" scoped></style>
